/**
 * @generated SignedSource<<fd1fb5b40a8594be7b23ba78e57725f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubmitSurveyResponsesInput = {
  clientMutationId?: string | null;
  surveyId: string;
};
export type submitSurveyResponsesMutation$variables = {
  input: SubmitSurveyResponsesInput;
};
export type submitSurveyResponsesMutationVariables = submitSurveyResponsesMutation$variables;
export type submitSurveyResponsesMutation$data = {
  readonly submitSurveyResponses: {
    readonly survey: {
      readonly viewerDidSubmit: boolean | null;
    } | null;
    readonly user: {
      readonly tasksList: ReadonlyArray<{
        readonly __typename: "RespondToSurveyTask";
        readonly survey: {
          readonly name: string;
          readonly entityId: string;
        };
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null>;
    } | null;
  } | null;
};
export type submitSurveyResponsesMutationResponse = submitSurveyResponsesMutation$data;
export type submitSurveyResponsesMutation = {
  variables: submitSurveyResponsesMutationVariables;
  response: submitSurveyResponsesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidSubmit",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "submitSurveyResponsesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubmitSurveyResponsesPayload",
        "kind": "LinkedField",
        "name": "submitSurveyResponses",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ViewerSurvey",
            "kind": "LinkedField",
            "name": "survey",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ViewerSurvey",
                        "kind": "LinkedField",
                        "name": "survey",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToSurveyTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "submitSurveyResponsesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubmitSurveyResponsesPayload",
        "kind": "LinkedField",
        "name": "submitSurveyResponses",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ViewerSurvey",
            "kind": "LinkedField",
            "name": "survey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ViewerSurvey",
                        "kind": "LinkedField",
                        "name": "survey",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "type": "RespondToSurveyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ApprovePeerNominationsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "CalibrateTalentReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ConfirmReceivingPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "CreateGoalForGoalCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "DocumentsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "EnableOneOnOneTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "EndRevieweeCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "FinalizeReviewPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "GiveFeedbackTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "PTORequestTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "PerformPostScoringReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "PerformReviewsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "PerformTalentReviewTaskType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "PublishGrowthAreaReminderTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "RespondToBackboneEmployeeRegistrationFormTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "RespondToPulseTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "RespondToSurveyAssignmentTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ReviewCompensationCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ReviewReportCheckinTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ScoreRevieweeTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "SelectPeersTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "SetupOneOnOnesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "SetupUpdatesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ShareCompensationCycleResultsToTeamTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "StartSurveyManagerActionPlanningTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "UpdateGoalTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "UpdateGoalsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "UpdateTotalRewardsCompanyCurrencyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ViewCalibrationGroupsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ViewCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ViewCompensationCycleTeamResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ViewCompensationTotalRewardsStatementTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ViewSharedCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ViewSurveyActionPlanTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "ViewSurveyCommentTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76feacc51f7c4b9c1fcc830e19197371",
    "id": null,
    "metadata": {},
    "name": "submitSurveyResponsesMutation",
    "operationKind": "mutation",
    "text": "mutation submitSurveyResponsesMutation(\n  $input: SubmitSurveyResponsesInput!\n) {\n  submitSurveyResponses(input: $input) {\n    survey {\n      viewerDidSubmit\n      id\n    }\n    user {\n      tasksList {\n        __typename\n        ... on RespondToSurveyTask {\n          survey {\n            name\n            entityId\n            id\n          }\n          id\n        }\n        ... on ApprovePeerNominationsTask {\n          id\n        }\n        ... on CalibrateTalentReviewTask {\n          id\n        }\n        ... on ConfirmReceivingPacketTask {\n          id\n        }\n        ... on CreateGoalForGoalCycleTask {\n          id\n        }\n        ... on DocumentsTask {\n          id\n        }\n        ... on EnableOneOnOneTask {\n          id\n        }\n        ... on EndRevieweeCycleTask {\n          id\n        }\n        ... on FinalizeReviewPacketTask {\n          id\n        }\n        ... on GiveFeedbackTask {\n          id\n        }\n        ... on PTORequestTask {\n          id\n        }\n        ... on PerformPostScoringReviewTask {\n          id\n        }\n        ... on PerformReviewsTask {\n          id\n        }\n        ... on PerformTalentReviewTaskType {\n          id\n        }\n        ... on PublishGrowthAreaReminderTask {\n          id\n        }\n        ... on RespondToBackboneEmployeeRegistrationFormTask {\n          id\n        }\n        ... on RespondToPulseTask {\n          id\n        }\n        ... on RespondToSurveyAssignmentTask {\n          id\n        }\n        ... on ReviewCompensationCycleTask {\n          id\n        }\n        ... on ReviewReportCheckinTask {\n          id\n        }\n        ... on ScoreRevieweeTask {\n          id\n        }\n        ... on SelectPeersTask {\n          id\n        }\n        ... on SetupOneOnOnesWithNewReportTask {\n          id\n        }\n        ... on SetupUpdatesWithNewReportTask {\n          id\n        }\n        ... on ShareCompensationCycleResultsToTeamTask {\n          id\n        }\n        ... on StartSurveyManagerActionPlanningTask {\n          id\n        }\n        ... on UpdateGoalTask {\n          id\n        }\n        ... on UpdateGoalsTask {\n          id\n        }\n        ... on UpdateTotalRewardsCompanyCurrencyTask {\n          id\n        }\n        ... on ViewCalibrationGroupsTask {\n          id\n        }\n        ... on ViewCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewCompensationCycleTeamResultsTask {\n          id\n        }\n        ... on ViewCompensationTotalRewardsStatementTask {\n          id\n        }\n        ... on ViewSharedCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewSurveyActionPlanTask {\n          id\n        }\n        ... on ViewSurveyCommentTask {\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f87db68ae31da7168979e365d0830b3e";

export default node;
